module.exports = "<p>\r\n  applicationsguarantor works!\r\n</p>\r\n"